import React from "react";
import { FormattedMessage } from "react-intl";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import MuiLink from "@mui/material/Link";

import { TVehicle } from "types";
import Suggestion from "./Suggestion";

import { SmartLink } from "helper/SmartLink";

interface ICard {
  example: TVehicle;
  length?: number;
  paperProps?: any;
}

const Card: React.FC<ICard> = ({ example, paperProps = {}, length = 4 }) => (
  <Paper {...paperProps}>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography variant="h6" component="h2">
        <FormattedMessage
          id="common.vorschlaege"
          defaultMessage="Auswahl aus dem Fahrzeugangebot"
        />
      </Typography>
      <MuiLink to="/catalog" component={SmartLink}>
        Zur Startseite mit Detailsuche
      </MuiLink>
    </Box>
    <Suggestion example={example} length={length} />
  </Paper>
);

export default Card;
